import HACKATHON from "assets/avalancheBarcelona.png";

export const NFTs = [
  {
    image: HACKATHON,
    title: "Avalanche - Barcelona",
    price: 1000,
  },
  // {
  //   image: HACKATHON,
  //   title: "Avalanche - Barcelona",
  //   price: 1000,
  // },
  // {
  //   image: HACKATHON,
  //   title: "Avalanche - Barcelona",
  //   price: 1000,
  // },
  // {
  //   image: HACKATHON,
  //   title: "Avalanche - Barcelona",
  //   price: 1000,
  // },
  // {
  //   image: HACKATHON,
  //   title: "Avalanche - Barcelona",
  //   price: 1000,
  // },
  // {
  //   image: HACKATHON,
  //   title: "Avalanche - Barcelona",
  //   price: 1000,
  // },
];
